<template>
  <section class="terms-page">
    <div class="container">
      <h2 class="page-title">Regulamin korzystania z aplikacji</h2>
      <div class="content" v-html="content"></div>
    </div>
  </section>
</template>

<script>
import getStaticPage from '../helpers/getStaticPage';
import updatePageTitle from '../helpers/updatePageTitle';

export default {
  name: 'TermsPage',
  data() {
    return {
      content: '',
    };
  },
  created() {
    getStaticPage('terms', (response) => {
      this.content = response;
    });

    updatePageTitle('Regulamin');
  },
  beforeRouteUpdate(to, from, next) {
    updatePageTitle('Regulamin');

    next();
  },
};
</script>

<style scoped>
.content {
  margin-bottom: 90px;
  line-height: 25px;
  font-size: 17px;
  text-align: justify;
}
</style>
